import React from "react";
import icon_formula from "../../Assets/png_jpg/icon_formula.png";

export default function C_V_FORMULA({ value, inPopup = false }) {
  // Helper to format: 1000.50 -> 1.000,50
  const formatDisplayValue = (val) => {
    if (val === null || val === undefined || val === "") return "";

    // Ensure it's a string and split integer/decimal parts
    const parts = val.toString().split(".");

    // Regex to add a dot every 3 digits for the integer part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Rejoin using a comma as the decimal separator
    return parts.join(",");
  };

  const displayValue = formatDisplayValue(value);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        // NEW: Adaptive styling for Popup vs Table
        padding: inPopup ? "8px" : "0 4px",
        backgroundColor: inPopup ? "#f8fafc" : "transparent",
        border: inPopup ? "1px solid #e2e8f0" : "none",
        borderRadius: inPopup ? "4px" : "0",
        boxSizing: "border-box",
        cursor: inPopup ? "not-allowed" : "default",
      }}
    >
      <div
        className="badge_small background_grey_light"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          margin: 0,
          padding: "2px 4px",
          borderRadius: "4px",
          opacity: inPopup ? 0.7 : 1, // slightly dim the badge in popup
        }}
        title="Calculated Formula"
      >
        <img
          src={icon_formula}
          alt="Formula"
          style={{ width: "12px", height: "12px", objectFit: "contain" }}
        />
      </div>

      <span
        title={displayValue}
        style={{
          display: "block",
          textAlign: "right",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          lineHeight: "1.5",
          fontSize: "12px",
          color: inPopup ? "#64748b" : "inherit", // Make text look "disabled" in popup
        }}
      >
        {displayValue || "-"}
      </span>
    </div>
  );
}
